import React, { useState } from 'react';
import API_BASE_URL from './config';

function ChangePassword({ currentUser, theme, toggleTheme }) {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleChangePassword = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        // Validation
        if (!currentPassword || !newPassword || !confirmPassword) {
            setError('All fields are required');
            return;
        }

        if (newPassword.length < 8) {
            setError('New password must be at least 8 characters');
            return;
        }

        if (newPassword !== confirmPassword) {
            setError('New passwords do not match');
            return;
        }

        try {
            const response = await fetch(`${API_BASE_URL}/change_password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({
                    current_password: currentPassword,
                    new_password: newPassword
                })
            });

            const data = await response.json();

            if (data.error) {
                setError(data.error);
            } else {
                setMessage('✅ Password changed successfully!');
                setCurrentPassword('');
                setNewPassword('');
                setConfirmPassword('');
            }
        } catch (err) {
            setError('Failed to change password. Please try again.');
            console.error('Error changing password:', err);
        }
    };

    return (
        <div className="container mt-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2>⚙️ Account Settings</h2>
                <button 
                    onClick={toggleTheme} 
                    className="theme-toggle"
                    title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
                >
                    {theme === 'light' ? '🌙' : '☀️'}
                </button>
            </div>

            <div className="row">
                <div className="col-md-6">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">User Information</h5>
                            <div className="mb-3">
                                <label className="form-label">Username:</label>
                                <p className="form-control-plaintext fw-bold">{currentUser?.username}</p>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Role:</label>
                                <p className="form-control-plaintext">
                                    <span className="badge bg-primary">
                                        {currentUser?.role === 'dev' && '🛠️ Dev'}
                                        {currentUser?.role === 'admin' && '🔑 Admin'}
                                        {currentUser?.role === 'manager' && '📊 Manager'}
                                        {currentUser?.role === 'viewer' && '👀 Viewer'}
                                    </span>
                                </p>
                            </div>
                            {currentUser?.email && (
                                <div className="mb-3">
                                    <label className="form-label">Email:</label>
                                    <p className="form-control-plaintext">{currentUser.email}</p>
                                </div>
                            )}
                            {currentUser?.full_name && (
                                <div className="mb-3">
                                    <label className="form-label">Full Name:</label>
                                    <p className="form-control-plaintext">{currentUser.full_name}</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Change Password</h5>
                            
                            {message && (
                                <div className="alert alert-success" role="alert">
                                    {message}
                                </div>
                            )}
                            
                            {error && (
                                <div className="alert alert-danger" role="alert">
                                    {error}
                                </div>
                            )}

                            <form onSubmit={handleChangePassword}>
                                <div className="mb-3">
                                    <label htmlFor="currentPassword" className="form-label">
                                        Current Password *
                                    </label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="currentPassword"
                                        value={currentPassword}
                                        onChange={(e) => setCurrentPassword(e.target.value)}
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="newPassword" className="form-label">
                                        New Password * (min 8 characters)
                                    </label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="newPassword"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        minLength="8"
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="confirmPassword" className="form-label">
                                        Confirm New Password *
                                    </label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="confirmPassword"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        required
                                    />
                                </div>

                                <button type="submit" className="btn btn-primary">
                                    Change Password
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-4">
                <h5>Password Requirements:</h5>
                <ul>
                    <li>Minimum 8 characters</li>
                    <li>Include a mix of letters, numbers, and symbols for better security</li>
                    <li>Don't reuse passwords from other sites</li>
                </ul>
            </div>
        </div>
    );
}

export default ChangePassword;

